<template>
  <div class="addcourse addcourseware coursewareModle commonAddcourse manageMeeting">
    <!--面包屑-->
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
       <span>首页</span>>
      <span><router-link :to="{name:'ManageMeeting'}">专题读片</router-link></span> >
      <span v-if="cutOut === 'Modify'">修改会议</span>
      <span v-else>新建会议</span>
    </div>
    <!--搜索框-->
    <div class="search medicalNews medical">
      <el-form ref="form" :rules="rules" :model="form" label-width="100px">
        <el-row>
          <el-col :span="11">
            <el-form-item :span="10" label="会议名称:" prop="ConfName">
              <el-col :span="20">
                <el-input v-model="form.ConfName" :maxlength="20" placeholder="请输入会议名称"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :span="10" label="会议时间:" prop="startDateStr">
              <el-col :span="20">
                <el-date-picker
                  v-model="form.startDateStr"
                  :title="form.startDateStr"
                  format="yyyy-MM-dd HH:mm"
                  type="datetime"
                  placeholder="选择时间"
                  @change="_dateChange">
                </el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :span="10" label="预计用时:" prop="ExpectTime">
              <el-col :span="19">
                <el-select v-model="form.ExpectTime" placeholder="请选择">
                  <el-option
                    v-for="item in ExpectTimes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item :span="10" label="主持人:" prop="confChairName">
              <el-col :span="20">
                <el-input v-model="form.confChairName" :disabled="true" ></el-input>
                <!--<el-select style="width: 100%;" v-model="form.confChairName" clearable placeholder="请选择主持人">-->
                  <!--<el-option v-for="item in hostList"-->
                             <!--:key="item.label"-->
                             <!--:label="item.label"-->
                             <!--:value="item.value">-->
                  <!--</el-option>-->
                <!--</el-select>-->
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item :span="10" label="会议地址:" prop="confAddress">
              <el-col :span="20">
                <el-input v-model="form.confAddress" :maxlength="10" placeholder="请输入地址"></el-input>
                <!--<el-select style="width: 100%;" v-model="form.confAddress" clearable filterable placeholder="手动输入地址或选择">-->
                  <!--<el-option v-for="item in confAddressList"-->
                             <!--:key="item.label"-->
                             <!--:label="item.label"-->
                             <!--:value="item.value">-->
                  <!--</el-option>-->
                <!--</el-select>-->
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="会议类型" prop="confPrivacy">
              <el-radio-group v-model="form.confPrivacy" @change="_radioSelect">
                <el-radio label="公开"></el-radio>
                <!--<el-form-item-->
                  <!--prop="confPwd"-->
                  <!--:rules="[-->
                    <!--{ type: 'number', message: '年龄必须为数字值'}-->
                  <!--]"-->
                <!--&gt;-->
                <el-input type="confPwd"  v-model="form.confPwd" class="setPassword" placeholder="可设置密码，6位数字" maxlength="6"></el-input>

                <!--</el-form-item>-->

                <el-radio label="私密"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="13" v-show="scopeShow">
            <el-form-item :span="10" label="参会人员  :">
              <el-col :span="20">
                <el-input @focus="_openScope" v-model="openMember" placeholder="请输入参会人员">
                </el-input>

              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--切换-->
    <div class="tabs-content">
      <div class="addCourse">
        <div v-show="addBtn" class="addBtn" @click="_addBtn">{{text}}</div>
      </div>
      <div class="tabs-text">
        <i class="arrow_first">></i>
        <i class="arrow_second">></i>
        <el-tabs v-model="activeName1" @tab-click="handleClick">
          <el-tab-pane label="1.选择相关影像" name="first">
            <p-table :operationWidth="operationWidth" :head="head" :data="data" :operation="operation" @_operation="_operation_" :height="height1"></p-table>
          </el-tab-pane>
          <el-tab-pane label="2.选择相关病例" name="second">
            <p-table :head="headVal" :data="dataVal" :operation="operation2" @_operation="_operation2_" :height="height1"></p-table>
          </el-tab-pane>
          <el-tab-pane label="3.上传其他附件" name="third">
            <upload @fileChange="fileChange" @fileRemove="fileRemove" :updateFileList="updateFileList" :updatePicList="updatePicList"></upload>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--确定取消按钮-->
    <div class="btn-box">
      <el-button @click="saveConfInfo('form')" class="save-hair">保存待发</el-button>
      <el-button @click="sendConfInfo('form')" class="saving">发送</el-button>
    </div>
    <!--会议冲突提醒-->
    <pops v-if="confConflictPop" :show="confConflictPop" :title="'会议冲突提醒'" @closePop="closeconfConflict" :class="'mrDialog'" :width="'60%'">
      <reportTable :data="hisdata" :head="hisConfhead" :height="hisheight" @showDetial="hisshowDetials" :operationWidth="'130'"></reportTable>
      <div class="btn-box">
        <el-button @click=" " class="save">继续发送</el-button>
        <el-button @click=" " class="cancel">取消</el-button>
      </div>
    </pops>
    <!--从本院影像获取-->
    <pops v-if="hospitalPop" :show="hospitalPop" :title="'从本院影像中选择'" @closePop="closeHospit" :class="'mrDialog'" :width="'980px'">
      <pImage @_popshow="receiveVal" @_popClose="receiveClose" :studyList="studyList"></pImage>
    </pops>
    <!--开放范围弹框-->
    <openFlagPop ref="getFlag" @openMemberVal="openMemberVal" @openMemberData="openMemberData"></openFlagPop>
    <!--从病例中选择弹框-->
    <pops v-if="popCase" :show="popCase" :title="'从病例库中选择'" @closePop="closePopCase" :width="'73%'">
      <div class="popScore popCourse queryCourse">
        <div class="popContent">
          <div class="leftCont medicalRecord_left">
            <div class="margin10_box medicalRecord_left">
              <collapse-medical-record @tabChange="tabChange" :tabs="tabs" @changeColl="changeColl"
                                       @delPerson="delPerson" @personClick="personClick"
                                       @searchClick="searchClick" :personList="personList" @addPersonList="addPersonList" :treeData="treeData"
                                       @treeNodeClick="treeNodeClick" :titleList="titleList" :filterText="filterText">
              </collapse-medical-record>
            </div>
          </div>
          <div class="rightCont">
            <div class="rightTitle">
              <span class="alreadyChoose">当前您已选择<i class="difColor">{{number}}</i>条病例</span>
              <span class="saveInput">
                <input v-model="search" class="_input" placeholder="请输入关键字搜索" type="text">
                <i class="point el-icon-search _inputTable" @click="tableCaseList"></i>
              </span>
            </div>
            <div class="borderCont">
              <zTable :head="head3" :data="tableData" :TableData="TableData" :height="height" @tableVal="tableVal" @ValLength="ValLength" ref="getSelection"></zTable>
              <page :total="page.total" :allPage="page.allPage" :currentPage="page.currentPage" @current-page="__currentPage" @page-size="__pageSize"></page>
            </div>
          </div>
        </div>
        <!--添加取消按钮-->
        <div class="btn-box   button-box">
          <el-button class="save btn" @click="addDataVal">添加</el-button>
          <el-button @click="_cancelCanse" class="cancel btn">取消</el-button>
        </div>
      </div>
    </pops>
    <!--病例详情弹框-->
    <casePop ref="getCase"></casePop>
    <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
    <fullscreen :loadingText="loadingText" :isFullscreen="isFullscreen"></fullscreen>
  </div>
</template>

<script type="text/ecmascript-6">
  import btns from '@/components/common/button/buttons'
  import collapse from '@/components/common/collapse/collapse'
  import tabs from '@/components/common/tabs/tabs'
  import tree from '@/components/common/tree/tree'
  import radiusInput from '@/components/common/radiusInput/radiusInput'
  import pTable from '@/components/common/tables/publicTable'
  import zTable from '@/components/common/tables/table'
  import casePop from '@/components/common/pops/casePop'
  import openFlagPop from '@/components/common/pops/openFlagPop'
  import alonebutton from '@/components/common/button/aloneButton'
  import pops from '@/components/common/pops/pop'
  import page from '@/components/common/page/page'
  import upload from "@/components/common/upload/uploadFile1"
  import pImage from '@/components/common/Image/imageSelection'
  import collapseMedicalRecord from '@/components/common/collapseMedicalRecord/collapseMedicalRecord'
  import reportTable from '@/components/common/tables/reportTable'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
  import {nomalTime} from '@/common/js/time'
  import {getLocalStorage, saveLocalStorage, clearLocalStorage} from '@/common/js/localStorage'
  import {changehosArea,changeAge,changeGender,changeSex,changeclinicType} from '@/common/js/change'
  import fullscreen from '@/components/common/base/fullscreen'//全屏遮罩
  import aycanImages from '@/components/common/base/aycanImages'
  export default {
    components: {
      collapse,
      tabs,
      tree,
      radiusInput,
      pTable,
      zTable,
      alonebutton,
      collapseMedicalRecord,
      pops,
      page,
      upload,
      pImage,
      btns,
      reportTable,
      casePop,
      openFlagPop,
      aycanImages,
      fullscreen
    },
    data() {
      return {
        page: {
          total: 0,
          currentPage: 0,
          pageSize: 10
        },

        scopeShow: false,
        hisheight: 350,
        loading: true,
        hospitalPop: false,
        confConflictPop: false,
        pop: false,
        cutOut: '',
        popCase: false,
        popDetail: false,
        popSaveData: false,
        activeName1: 'first',
        activeName: '1',
        search:'',
        openMember: '',
        openMemberList: [],
        updateFileList: [],
        updatePicList: [],
        member:'',
        number:'0',
        operationWidth:'100',
        isFullscreen:false,//是否显示全屏遮罩
        loadingText:"提交中，请稍后.......",
        text: '从本院影像选择',
        addBtn: true,
        isFullscreen:false,//是否显示全屏遮罩
        loadingText:"提交中，请稍后.......",
        form: {
          ConfName: '',
          startDateStr: '',
          ExpectTime: '',
          confChairName: '',
          confAddress: '',
          confPrivacy: '公开',
          confPwd: ''
        },
        ExpectTimes: [{
          value: '0.5',
          label: '0.5小时'
        },{
          value: '1',
          label: '1小时'
        },{
          value: '1.5',
          label: '1.5小时'
        },{
          value: '2',
          label: '2小时'
        },{
          value: '2.5',
          label: '2.5小时'
        },{
          value: '3',
          label: '3小时'
        },{
          value: '3.5',
          label: '3.5小时'
        },{
          value: '4',
          label: '4小时'
        }],
        // hostList: [{
        //   value: '0',
        //   label: '会议新建者本人'
        // },{
        //   value: '1',
        //   label: '会议新建者本人'
        // }],
        confAddressList: [{
          value: '0',
          label: 'A幢2楼401'
        },{
          value: '1',
          label: 'D幢2楼401'
        }],
        hisConfhead: [
          {
            props: 'personType',
            label: '人员类型',
            columnWidth: 115
          },
          {
            props: 'infoTitle',
            label: '信息标题',
            columnWidth: 300
          },
          {
            props: 'startTime',
            label: '开始时间',
            columnWidth: 150
          },
          {
            props: 'endTime',
            label: '结束时间',
            columnWidth: 150
          }
        ],
        deptName: '',
        medicDetail:'',
        isPerson: false,
        showCheckBox: false,
        treeData: [],
        height: 290,
        height1: 400,
        openFlag: '1',
        remark: '',
        medicalVal:'',
        confId:'',//会议id
        titleList: [
          { title: "自定义分类", name: "4" },
          { title: "按诊断分类", name: "1" },
          { title: "按部位分类", name: "2" },
          { title: "按科室分类", name: "3" }
        ],
        personList: [],
        tabs: [
          {label: '公共分类', name: '0'},
          {label: '个人分类', name: '1'}
        ],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        rules: {
          ConfName: [
            {required: true, message: '请输入会议名称', trigger: 'blur'}
          ],
          startDateStr: [
            { required: true, message: '请选择会议时间', trigger: 'change' }
          ],
          ExpectTime: [
            { required: true, message: '请选择预计时间', trigger: 'change' }
          ],
          confChairName: [
            { required: true, message: '请选择主持人', trigger: 'blur' }
          ],
          confAddress: [
            { required: true, message: '手动输入地址或选择', trigger: 'blur' }
          ],
          confPrivacy: [
            {required: true, message: '请选择是否公开', trigger: 'change'}
          ],
        },
        options: [{
          value: '0',
          label: '男'
        }, {
          value: '1',
          label: '女'
        }],
        sex: '',
        options2: [{
          value: '1',
          label: '岁'
        }, {
          value: '2',
          label: '月'
        }],
        garal: '岁',
        tableKeyWords:'',
        filterText:'',
        // deptId:'',
        commonUserId:'',
        rightTabActive: "1",
        hospitalId: '',
        head: [
          {
            props: 'hospitalName',
            label: '来源',
            width: '10%'
          },
          {
            props: 'hospitalName',
            label: '院区',
            width: '10%'
          },{
            props: 'patientId',
            label: '患者编号',
            width: '12%'
          },{
            props: 'accessionNumber',
            label: '检查编号',
            width: '10%'
          },
          {
            props: 'patientName',
            label: '患者姓名',
            width: '8%'
          },
          {
            props: 'examTypeName',
            label: '类型',
            width: '12%'
          },
          {
            props: 'examBodyName',
            label: '检查部位',
            width: '12%'
          },
          {
            props: 'examDate',
            label: '检查时间',
            width: '18%'
          }
        ],
        headVal:
          [
            {
              props: "caseName",
              label: "病例名称"
            },
            {
              props: "privateType",
              label: "访问权限"
            },
            {
              props: "caseSex",
              label: "性别"
            },
            {
              props: "caseAge",
              label: "年龄"
            },
            {
              props: "createDateStr",
              label: "创建时间"
            },
            {
              props: "creatorName",
              label: "创建人"
            }
          ],
        head3: [
          {
            props: "caseName",
            label: "病例名称"
          },
          {
            props: "privateType",
            label: "访问权限"
          },
          {
            props: "caseSex",
            label: "性别"
          },
          {
            props: "caseAge",
            label: "年龄"
          },
          {
            props: "createDateStr",
            label: "创建时间"
          },
          {
            props: "creatorName",
            label: "创建人"
          }
        ],
        data: [],
        data3: [],
        data4: [],
        dataVal: [],
        groupIds: [],
        tableData: [],
        TableData:[],
        operation: [
          {
            name: '阅片',
            operation: '',
            class: 'icon-yuepian'
          },
          {
            name: '移除',
            operation: '',
            class: 'icon-yichu'
          }
        ],
        operation2: [
          {
            name: '查看',
            operation: '',
            class: 'icon-chakan'
          },
          {
            name: '移除',
            operation: '',
            class: 'icon-yichu'
          }
        ],
        caseList: [],
        attachList: [],
        oldAttachList: [],
        typeName: '',
        studyList:[],
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        }
      }
    },
    mounted() {
      // 登录用户信息
      http.post('/getUserInfo.json').then(res => {
        if (res.data.code === _.ERR_OK) {
          this.form.confChairName = res.data.model.userName
        }
      }).catch(() => {

      })
    },
    methods: {
      _openScope() {  //参会人员选择
        this.$refs.getFlag.openFlag()
      },
      openMemberVal(val){
        this.openMember = val
      },
      openMemberData(val){
        this.openMemberList = val
      },
      timeStartchange() { //会议时间选择，清空结束时间
        this.form.eventTimeend = ''
      },
      _radioSelect(tab) {
        if (tab === '公开') {
          this.scopeShow = false
          this.openFlag = '1'
        } else if (tab === '私密') {
          this.scopeShow = true
          this.openFlag = '0'
        }
      },
      saveConfInfo(form) { //保存代发
            //判断密码是否为纯数字
        let reg=/^\d+$/; //判断字符串是否为数字 ，判断正整数用/^[1-9]+[0-9]*]*$/
        if(this.form.confPwd){
          if(!reg.test(this.form.confPwd) && this.form.confPwd != '') {
          message('密码必须是纯数字', false)
          return false
          }
        }

        let startTime = new Date(this.form.startDateStr)
        let startDate = ""
        let openFlag = ''
        let startgetMonth=startTime.getMonth() + 1
        let startGetDate=startTime.getDate()
        let startGetHours=startTime.getHours()
        let startGetMinutes=startTime.getMinutes()
        let startGetSeconds=startTime.getSeconds()+10
        if(startGetDate<10){
          startGetDate='0'+startGetDate
        }
        if(startgetMonth<10){
          startgetMonth='0'+startgetMonth
        }
        if(startGetHours<10){
          startGetHours='0'+startGetHours
        }
        if(startGetMinutes<10){
          startGetMinutes='0'+startGetMinutes
        }
        if(startGetSeconds<10){
          startGetSeconds='0'+startGetSeconds
        }
        startDate = startTime.getFullYear() + '-' + startgetMonth + '-' + startGetDate + ' ' + startGetHours + ':' + startGetMinutes + ':' + startGetSeconds
        if(this.form.confPrivacy == '公开') {
          openFlag = '1'
        } else {
          openFlag = '0'
        }
        let caseList = []
        for (let item of this.dataVal) {
          caseList.push({
            id: item.id,
            creator: item.creator,
            creatorName: item.creatorName,
            isDelete: item.isDelete,
            caseName: item.caseName
          })
        }
        let studyList = []
        for(let item of this.data) {
          studyList.push({
            studyPk: item.studyPk,
            hospitalId: item.hospitalId
          })
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let params = {
              id: this.confId,
              confName: this.form.ConfName,
              startDateStr: startDate,
              timeCount: this.form.ExpectTime,//会议耗时
              confChairName: this.form.confChairName,
              confAddress: this.form.confAddress,
              confPwd: this.form.confPwd,
              openFlag: openFlag,
              attendList: this.openMemberList,
              caseList: caseList,
              studyList: studyList,
              attachList: this.oldAttachList || []
            }
            for (let item of params.attachList) {
              for (var key in item) {
                if (
                  key !== "fileid" &&
                  key !== "attach_name" &&
                  key !== "attach_type" &&
                  key !== "atatch_size"
                ) {
                  delete item[key];
                }
              }
            }
             if(this.openFlag === "0"){
                  if(this.openMember === ''){
                    message('请选择开放范围', false)
                  }else{
                  http.post('/conference/saveTopicConfInfo.json', params).then(res => {
                    if (res.data.code === _.ERR_OK) {
                      message(res.data.msg, true)

                     this.$router.go(-1)
                    } else {
                      message(res.data.msg, false)
                    }
                  }).catch(err => {
                    errMsg(err)
                  })
                  }
                }else{
                 http.post('/conference/saveTopicConfInfo.json', params).then(res => {
                    if (res.data.code === _.ERR_OK) {
                     message(res.data.msg, true)
                     this.$router.go(-1)
                    } else {
                      message(res.data.msg, false)
                    }
                  }).catch(err => {
                    errMsg(err)
                  })
             }
            } else {
            return false
          }
        })
      },
      sendConfInfo(form) { //发送新增会议
         //判断密码是否为纯数字
        let reg=/^\d+$/; //判断字符串是否为数字 ，判断正整数用/^[1-9]+[0-9]*]*$/
        if(this.form.confPwd){
          if(!reg.test(this.form.confPwd) && this.form.confPwd != '') {
          message('密码必须是纯数字', false)
          return false
          }
        }

        let startTime = new Date(this.form.startDateStr)
        let startDate = ""
        let openFlag = ''
        let startgetMonth=startTime.getMonth() + 1
        let startGetDate=startTime.getDate()
        let startGetHours=startTime.getHours()
        let startGetMinutes=startTime.getMinutes()
        let startGetSeconds=startTime.getSeconds()+10
        if(startGetDate<10){
          startGetDate='0'+startGetDate
        }
        if(startgetMonth<10){
          startgetMonth='0'+startgetMonth
        }
        if(startGetHours<10){
          startGetHours='0'+startGetHours
        }
        if(startGetMinutes<10){
          startGetMinutes='0'+startGetMinutes
        }
        if(startGetSeconds<10){
          startGetSeconds='0'+startGetSeconds
        }
        startDate = startTime.getFullYear() + '-' + startgetMonth + '-' + startGetDate + ' ' + startGetHours + ':' + startGetMinutes + ':' + startGetSeconds
        if(this.form.confPrivacy == '公开') {
          openFlag = '1'
        } else {
          openFlag = '0'
        }
        let caseList = []
        for (let item of this.dataVal) {
          caseList.push({
            id: item.id,
            creator: item.creator,
            creatorName: item.creatorName,
            isDelete: item.isDelete,
            caseName: item.caseName
          })
        }
        let studyList = []
        for(let item of this.data) {
          studyList.push({
            studyPk: item.studyPk,
            hospitalId: item.hospitalId
          })
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let params = {
              id: this.confId,
              confName: this.form.ConfName,
              startDateStr: startDate,
              timeCount: this.form.ExpectTime,//会议耗时
              confChairName: this.form.confChairName,
              confAddress: this.form.confAddress,
              confPwd: this.form.confPwd,
              openFlag: openFlag,
              attendList: this.openMemberList,
              caseList: caseList,
              studyList: studyList,
              attachList: this.oldAttachList || []
            }
            for (let item of params.attachList) {
              for (var key in item) {
                if (
                  key !== "fileid" &&
                  key !== "attach_name" &&
                  key !== "attach_type" &&
                  key !== "atatch_size"
                ) {
                  delete item[key];
                }
              }
            }
            this.isFullscreen=true
            http.post('/conference/sendSingleTopicConf.json', params).then(res => {
               this.isFullscreen=false
              if (res.data.code === _.ERR_OK) {
                message(res.data.msg, true)
                this.$router.go(-1)
              } else {
                message(res.data.msg, false)
              }
            }).catch(err => {
               this.isFullscreen=false
              errMsg(err)
            })
          } else {
            return false
          }
        })
      },
      __pageSize(payload) {
        this.page.pageSize = payload
        this.tableCaseList()
      },
      __currentPage(val) {
        this.page.currentPage = val
        this.getTableList()
      },
      fileChange(val) {
        this.oldAttachList = val
      },
      fileRemove(val) {
        this.attachList.splice(this.attachList.indexOf(val[val.length - 1]), 1)
      },
      _operation_(payload) { //本院影像数据的阅片和删除
        if (payload.operation === 'icon-yuepian') {
          this.params_image.hospitalId = this.data[payload.index].hospitalId;
          this.params_image.studyPk = this.data[payload.index].studyPk+"";
          this.params_image.studyUid = this.data[payload.index].studyUid;
          this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })
          // let Aycan = {
          //   hospitalId:this.data[payload.index].hospitalId,
          //   studyPk:this.data[payload.index].studyPk,
          //   studyUid:this.data[payload.index].studyUid,
          // }
          // http.post('/edu/prepareAycan.json', Aycan).then(res => {
          //   if (res.data.code == "0000") {
          //       window.open(res.data.model,'_blank');
          //   }else{
          //     message('该病人无初始影像',false);
          //   }
          // }).catch(() => {
          // })
        } else if (payload.operation === 'icon-yichu') {
          this.$confirm('是否确定要移除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.data.splice(payload.index, 1)
          })
        }
      },
      _operation2_(payload) { //病例操作查看和阅片
        if (payload.operation === 'icon-chakan') {
          this.$refs.getCase.openCase(payload.id)
        } else if (payload.operation === 'icon-yichu') {
          this.$confirm('是否确定要移除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataVal.splice(this.dataVal.indexOf(payload), 1)
          })
        }
      },
      _addBtn() {   //本院影像和病例库按钮切换
        if (this.text === '从本院影像选择') {
          this.hospitalPop = true
          this.studyList = this.data
          let isModify = getLocalStorage('isModify')
          if(isModify) {
            saveLocalStorage(true, 'trigger')
          }
        } else if (this.text === '从病例库中选择') {
          this.TableData = []
          this.popCase = true
          this._getTreeData()
          this._getTreeData(1)
          this.tableCaseList()
        }
      },
      closeHospit(payload) {
        this.hospitalPop = payload;
      },
      closeconfConflict(payload) {
        this.confConflictPop = payload
      },
      receiveClose(){
        this.hospitalPop = false
      },
      closePop(payload) {
        this.pop = payload
      },
      closePopCase(payload) {
        this.popCase = payload
      },
      closePopDetail(payload) {
        this.popDetail = payload
      },
      _cancelCanse() {
        this.popCase = false
      },
      _savePopDetail() {
        this.popDetail = false
      },
      _cancel() {
        this.popDetail = false
      },
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      receiveVal(val) {  //从本院影像中获取数据
        if(val.length!==0) {
          this.data = val
          this.hospitalPop = false
        }
      },
      tableVal(val) {
        this.medicalVal = val
      },
      ValLength(val) {
        this.number = val
      },
      addDataVal() {
        this.dataVal = []
        this.$refs.getSelection.getList();
        this.popCase = false
        this.dataVal = this.medicalVal
      },
      _getTreeData(privateType = 0, keyWord='', subType) {
        let parmars = {
          privateType,
          keyWord,
          subType
        };
        http.post("/catalog/queryCaseCatalogTree.json", parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            if (privateType === 0) {
              this.allTreeData = res.data.model;
              this.changeColl('1')
            } else {
              this.oldPersonList = res.data.model;
              this.personList = res.data.model;
            }
          }
        });
      },
      addPersonList(val) {
        this.$prompt('请输入病例名', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
          // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          let parmars = {
            privateType: '1',
            catalogName:　value
          }
          http.post('catalog/addCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '提交成功'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      changeColl(playlod) {
        this.defaultTreeChecked = []
        this.filterText = ''
        this.treeData = []
        setTimeout(() => {
          // 1==>部位 2==>诊断 3==>科室
          let [flag, arr] = ['DIANOG', []];
          if (playlod === '1') {
            flag = 'DIANOG';
          } else if (playlod === '2') {
            flag = 'PART';
          } else if (playlod === '3') {
            flag = 'DEPT';
          } else {
            flag = 'CUSTOMER';
          }
          this.treeData = []
          arr = this.allTreeData.filter(item => item.subType === flag)
          for (let item of arr) {
            if (item.parentId === 0) {
              this.treeData.push({
                id: item.id,
                label: item.catalogName,
                children: this.allTreeData.filter(c => c.parentId === item.id)
              })
            }
          }
          for (let item of this.treeData) {
            if (item.children.length > 0) {
              for (let cItem of item.children) {
                cItem.label = cItem.catalogName
              }
            }
          }
        }, 400)
      },
      treeNodeClick(val) {
        this.getTableList(this.personFlag, val.id)
      },
      delPerson(val) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let parmars = {
            id: val.id
          }
          http.post('catalog/deleteCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      getTableList(privateType=0,catalogId) {
        let parmars = Object.assign({
          catalogId,
          privateType,
          keyWord: this.tableKeyWords
        }, this.page)
        http.post('caselib/queryCaseList.json', parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.tableData = res.data.model
            this.page.total = res.data.totalItem
            this.page.currentPage = res.data.currentPage
            for (let item of this.tableData) {
              item.caseSex = _.SEXOBJ[item.caseSex]
              item.privateType = _.privateType[item.privateType]
              if(item.caseAge!==undefined){
                if (item.ageUnit === '4') {
                  item.caseAge = item.caseAge + '岁'
                } else if (item.ageUnit === '3') {
                  item.caseAge = item.caseAge + '月'
                } else if (item.ageUnit === '2') {
                  item.caseAge = item.caseAge + '周'
                } else if(item.ageUnit === '1'){
                  item.caseAge = item.caseAge + '天'
                } else if(item.ageUnit === '5'){
                  item.caseAge = item.caseAge + '小时'
                }
              } else {
                item.caseAge = ''
              }
            }
            this.TableData = this.dataVal
          }
        })
      },
      searchClick(val) {
        this.filterText = val
        this.personList = this.oldPersonList.filter(item => item.catalogName.includes(val))
      },
      tableCaseList() {
        this.tableKeyWords = this.search
        this.getTableList()
      },
      rightTabChange(payload) {
        this.activeName = payload.name;
        this.rightTabActive = payload.name;
      },
      tabChange(payload) {
        this.page.currentPage = 1
        this.filterText = ''
        this.personFlag = payload.name
        // console.log(this.oldPersonList)
        this.personList = this.oldPersonList
        if (payload.name === "1") {
          this.isPerson = true;
        } else {
          this.isPerson = false;
        }
        this.getTableList(payload.name)
        this._getTreeData();
      },
      stepMove(num) {
        this.activeName = (this.activeName - 0 + num).toString();
        this.rightTabActive = (this.rightTabActive - 0 + num).toString();
      },
      personClick(val) {
        this.getTableList(this.personFlag, val.id)
      },
      getUserInfo() {
        http.post('/getUserInfo.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            this.hospitalId = res.data.model.hosId
            this.founder = res.data.model.userName
            saveLocalStorage(res.data.model.userName, 'userName')
          } else {
          }
        }).catch(err => {
        })
      },
      changeGender(val){
        let gander;
        val.replace(/\s+/g, "") == "F" ? gander='女':gander= '男';
        return gander;
      },
      _dateChange(picker){
          let date = new Date()
         if(picker <date.setTime(date.getTime() - 3600) ){
           this.form.startDateStr='';
           this.rules.startDateStr[0].message=" 会议时间不小于当前时间！"
         }else{

          }
      },
    },
    created() {
      this.getUserInfo()
      let isModify = getLocalStorage('isModify')
      if(isModify) {
        let detailData = getLocalStorage('bianjiData')

        this.confId = detailData.id
        this.form.ConfName = detailData.confName
        this.form.startDateStr = detailData.startDateStr
        this.form.ExpectTime = detailData.timeCount
        this.form.confChairName = detailData.confChairName
        this.form.confAddress = detailData.confAddress
        this.form.confPwd = detailData .confPwd
        if(detailData.openFlag == '1') {
          this.form.confPrivacy = '公开'
        } else {
          this.form.confPrivacy = '私密'
          this.scopeShow = true
        }
        var examinePart = "";   //开放范围修改部分
        let par = {}
        for (let item of detailData.attendList) {
          if(item.attendType == '3'){
            par = {
              id: item.groupId,
              name: item.groupName,
              job: '',
              attebdType: item.attendType
            }
          }else if(item.attendType =='2'){
            par = {
              id: item.hosId,
              name: item.hosName,
              job: '',
              attebdType: item.attendType
            }
          }else if(item.attendType =='1'){
            par = {
              id: item.deptId,
              name: item.deptName,
              job: item.hosName,
              attebdType: item.attendType
            }
          }else{
            par = {
              id: item.userId,
              name: item.userName,
              job: item.docTitle,
              attebdType: item.attendType
            }
          }
          examinePart +="，" + par.name;
          if (examinePart.substr(0,1)=='，')
            examinePart=examinePart.substr(1);
        }
        this.openMember = examinePart
        this.openMemberList = detailData.attendList

        this.data = detailData.studyList
        for(let item of this.data) {
          item.hosArea = changehosArea(item.hosArea)
          item.examDate = nomalTime(item.examDate)
        }
        this.studyList = this.data
        for (let item of detailData.caseList) {
          if(item.caseSex === '1') {
            item.caseSex = '男'
          } else {
            item.caseSex = '女'
          }
          if(item.privateType === 0) {
            item.privateType = "公共"
          } else if(item.privateType === 1) {
            item.privateType = "个人"
          } else if(item.privateType === 2) {
            item.privateType = "部门公开"
          } else if(item.privateType === 3) {
            item.privateType = "医院公开"
          }
          if(item.caseAge!==undefined){
            item.caseAge = item.caseAge + changeAge(item.ageUnit)
          } else {
            item.caseAge = ''
          }




          // if (item.ageUnit === '4') {
          //   item.caseAge = item.caseAge + '岁'
          // } else if (item.ageUnit === '3') {
          //   item.caseAge = item.caseAge + '个月'
          // } else if (item.ageUnit === '2') {
          //   item.caseAge = item.caseAge + '周'
          // } else if (item.ageUnit === '1'){
          //   item.caseAge = item.caseAge + '天'
          // } else if(item.ageUnit === '5'){
          //   item.caseAge = item.caseAge + '小时'
          // }
        }
        this.oldAttachList = detailData.attachList || []
        this.dataVal = detailData.caseList
        this.tableData = this.dataVal
        if (detailData.attachList.length > 0) {
          for (let item of detailData.attachList) {
            if (item.attach_type === 'file') {
              this.updateFileList.push(item)
            } else {
              this.updatePicList.push(item)
            }
          }
        }
        for (let item of detailData.attachList) {
          delete item.createDate
        }
        this.attachList = detailData.attachList || []
      }
      if (this.$route.name.indexOf("Modify") > -1) {
        this.cutOut = 'Modify'
      }
    },
    watch: {
      activeName1(c, o) {
        if (c == 'first') {
          this.text = '从本院影像选择'
          this.addBtn = true
        } else if (c == 'second') {
          this.text = '从病例库中选择'
          this.addBtn = true
        } else if (c == 'third') {
          this.addBtn = false
        }
      },
      popShow(c) {
        this.getTableList()
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .commonAddcourse
    height: calc(100vh - 50px)
    overflow-y: auto
  .addCourse
    height: 40px
    float:right
    background: $color-background-d
    margin-bottom: -10px

  .select-time input
    width:100%
  .setPassword
    width: 170px
    color: #606266
    margin: 0 15px
  .closeBtn
    width: 18px
    height: 18px
    display: inline-block
    font-size: 15px
    text-align: center
    line-height: 16px
    background: #d7d6d6
    border-radius: 50%
    margin-left: 3px
    color: $color-index-text
    cursor: pointer

  .tabs-content
    overflow: hidden
    background: $color-index-text

  .addBtn
    float: right
    width: 120px
    height: 27px
    position: relative
    top: 11px
    right: 20px
    line-height: 27px
    text-align: center
    cursor: pointer
    background: $color-btn
    color: $color-index-text
    border-radius: 3px
    z-index: 233

  .search
    background: $color-index-text
    margin-bottom: 16px
    padding: 15px 0

  ._member
    line-height: 26px !important
    border: 1px solid #dcdfe6

  .memberNull
    height: 26px
  .memberTrue
    height: 400px
    overflow-y: auto
    overflow-x: hidden
  .scient
    position: relative
    left: -8px

  .arrow_first
    position: relative;
    top: 15px;
    left: 130px;

  .rtHeight
    overflow-y: auto

  .overtHeight
    height: 100%

  .rightList
    margin: 5px 10px
    float: left

  .arrow_second
    position: relative
    top: 15px
    left: 250px

  .tabs-text
    position: relative
    .el-tabs
      margin-top -10px
  .radius_input
    min-width: 200px
    width: 70%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    position: absolute
    right: 20px
    top: -14px
    padding: 0 20px

  .rSearch
    position: relative
    margin-bottom: 10px

  .point
    position: absolute
    right: 20px
    top: 5px

  ._input
    min-width: 200px
    width: 100%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    right: 20px
    top: -14px
    padding: 0 20px
    box-sizing: border-box;

  .secPoint
    right: 10px

  ._inputTable
    top: 13px

  .btn-box
    text-align: center
    margin: 40px 0
    .save-hair, .saving, .save, .cancel
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
    .save
      background: $color-background-hover
      margin-right: 80px
    .commonBtn
      width: 90px
    .cancel
      background: $button-del
    .save-hair
      background: $button-base-color
      margin-right: 80px
    .saving
      background: $color-background-hover
  .button-box
     clear:both;
     margin-left: 28%;

</style>



// WEBPACK FOOTER //
// addManageMeeting.vue?03fb5730